import Container from './PublishedLayout.container';
import PublishedLayout from './PublishedLayout';

export default Container(PublishedLayout);
